var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crumb-title"},[_c('div',{staticClass:"crumb-box"},[_c('a-breadcrumb',{attrs:{"separator":"/"}},[(Object.prototype.toString.call(_vm.roots)=='[object Array]')?_vm._l((_vm.roots),function(item){return _c('a-breadcrumb-item',{key:item.to},[_c('router-link',{staticClass:"config-index",attrs:{"to":{ name: item.to,
                   params: {
                     pid: _vm.pid
                   },
                   query: Object.assign({}, item.query)
            }}},[_vm._v("\n            "+_vm._s(item.title)+"\n          ")])],1)}):[_c('a-breadcrumb-item',[_c('router-link',{staticClass:"config-index",attrs:{"to":{ name: _vm.roots.to,
                   params: {
                     pid: _vm.pid
                   },
                   query: Object.assign({}, _vm.roots.query)
            }}},[_vm._v("\n            "+_vm._s(_vm.roots.title)+"\n          ")])],1)],_c('a-breadcrumb-item',[_vm._t("breadTit")],2)],2)],1),_c('div',{staticClass:"second-tit"},[_c('h2',[_vm._t("secondTit")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }